<div
  *ngIf="user && accountLicenses && licensePermissions && allLicenses"
  class="row"
>
  <div class="right-border col">
    <h4><i class="fas fa-unlock-alt"></i> Global permissions</h4>
    <div class="permissions-list permissions-list-optional">
      <app-switch-checkbox
        [innerId]="'checkbox_globalpermissions_' + permission"
        *ngFor="let permission of coreLicensePermissions?.permissions"
        [checked]="
          coreLicensePermissions.code
            | hasPermissionPipe: permission:licensePermissionsForAccountUser
        "
        (change)="onToolChange(coreLicensePermissions.code, permission, $event)"
        placement="right"
        [ngbTooltip]="getToolTipText(coreLicensePermissions, permission)"
        [disabled]="
          !canTogglePermissions ||
          isUpdatingLicenseTool ||
          !isEditable(coreLicensePermissions, permission)
        "
        [disableTooltip]="isEditable(coreLicensePermissions, permission)"
      >
        {{ permission }}
      </app-switch-checkbox>
    </div>

    <h4><i class="fas fa-rocket"></i> Prelaunch permissions</h4>
    <br />
    <div *ngFor="let license of coreLicenses">
      <app-bordered-group
        *ngIf="license.code"
        [header]="getDisplayName(license.code)"
      >
        <app-switch-checkbox
          [innerId]="
            'checkbox_prelaunchpermissions_' + license.code + '_' + permission
          "
          *ngFor="let permission of license.permissions"
          [checked]="
            license.code
              | hasPermissionPipe: permission:licensePermissionsForAccountUser
          "
          (change)="onToolChange(license.code, permission, $event)"
          [disabled]="
            !canTogglePermissions ||
            isUpdatingLicenseTool ||
            !isLicenseStateSuccess(license.code) ||
            !isEditable(license, permission)
          "
          placement="right"
          [ngbTooltip]="getToolTipText(license, permission)"
          [disableTooltip]="
            hasLicense(license.code) && isEditable(license, permission)
          "
        >
          {{ permission }}
        </app-switch-checkbox>
      </app-bordered-group>
    </div>
  </div>

  <div class="right-border col">
    <h4><i class="fas fa-toolbox"></i> License permissions</h4>
    <div class="permissions-list tools-permissions">
      <div *ngFor="let license of allLicensesExceptCore">
        <app-bordered-group
          *ngIf="license.code && hasLicense(license.code)"
          [header]="getDisplayName(license.code)"
        >
          <app-switch-checkbox
            [innerId]="
              'checkbox_licensepermissions_' + license.code + '_' + permission
            "
            *ngFor="let permission of license.permissions"
            [checked]="
              license.code
                | hasPermissionPipe: permission:licensePermissionsForAccountUser
            "
            (change)="onToolChange(license.code, permission, $event)"
            [disabled]="
              !canTogglePermissions ||
              isUpdatingLicenseTool ||
              !isLicenseStateSuccess(license.code) ||
              !isEditable(license, permission)
            "
            placement="right"
            [ngbTooltip]="getToolTipText(license, permission)"
            [disableTooltip]="
              hasLicense(license.code) && isEditable(license, permission)
            "
          >
            {{ permission }}
          </app-switch-checkbox>
        </app-bordered-group>
      </div>
    </div>
  </div>

  <div class="col right-border">
    <h4><i class="fas fa-chart-pie"></i> Sections</h4>
    <div class="sections-list">
      <div *ngFor="let section of allSections" class="word-wrap">
        <app-switch-checkbox
          [stylingClass]="'col-auto'"
          [innerId]="'checkbox_section_' + section.id"
          [disabled]="
            !canTogglePermissions ||
            isUpdatingSections ||
            isUpdatingLicenseTool ||
            (LicenseCode.Core
              | hasPermissionPipe
                : Permission.AccountCanManage
                : licensePermissionsForAccountUser)
          "
          [checked]="
            (LicenseCode.Core
              | hasPermissionPipe
                : Permission.AccountCanManage
                : licensePermissionsForAccountUser) ||
            (user.sections | sectionPermissionPipe: section.id)
          "
          (change)="onSectionChange($event, section.id)"
          placement="right"
        >
          <i
            [ngbTooltip]="toolTip"
            [ngClass]="section.hidden ? 'fa-eye-slash' : 'fa-eye'"
            class="far"
          ></i>
          <ng-template #toolTip>
            <div class="d-flex flex-column">
              <span>{{ section.hidden ? 'Hidden' : 'Visible' }}</span>
              <span>{{
                'Note: hide/unhide can only be done from One account settings'
              }}</span>
            </div>
          </ng-template>
          {{ section.name }}
        </app-switch-checkbox>
      </div>
    </div>
  </div>
</div>
